import { taggedTemplateLiteral as _taggedTemplateLiteral, slicedToArray as _slicedToArray } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled__default from 'styled-components';
import React, { useState, Children } from 'react';
import { StepperContext } from './StepperContext.js';
import StepperHeader from './StepperHeader.js';

var _templateObject;
var Step = styled__default('div')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: ", ";\n"])), function (_ref) {
  var visible = _ref.visible;
  return visible ? 'block' : 'none';
});
var Stepper = function Stepper(_ref2) {
  var stepTitles = _ref2.stepTitles,
    onCompleted = _ref2.onCompleted,
    onStepChange = _ref2.onStepChange,
    onStepCompleted = _ref2.onStepCompleted,
    children = _ref2.children;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    currentStepIndex = _useState2[0],
    setCurrentStepIndex = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    stepThatCalledEdit = _useState4[0],
    setStepThatCalledEdit = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    editing = _useState6[0],
    setEditing = _useState6[1];
  var steps = Children.toArray(children);
  var stepperOnCompleted = onCompleted || function () {
    return null;
  };
  var stepperOnStepChange = onStepChange || function () {
    return null;
  };
  var stepperOnStepCompleted = onStepCompleted || function () {
    return null;
  };
  var stepperApi = {
    back: function back() {
      setEditing(false);
      if (currentStepIndex > 0) {
        var newStepIndex = currentStepIndex - 1;
        stepperOnStepChange(newStepIndex);
        setCurrentStepIndex(newStepIndex);
      }
    },
    completeEdit: function completeEdit() {
      setEditing(false);
      if (editing) {
        stepperOnStepChange(stepThatCalledEdit);
        setCurrentStepIndex(stepThatCalledEdit);
      }
    },
    currentStep: stepTitles[currentStepIndex],
    edit: function edit(step) {
      setStepThatCalledEdit(currentStepIndex);
      setEditing(true);
      stepperOnStepChange(step);
      setCurrentStepIndex(step);
    },
    goToStep: function goToStep(step) {
      setEditing(false);
      stepperOnStepChange(step);
      setCurrentStepIndex(step);
    },
    isEditing: function isEditing() {
      return editing;
    },
    next: function next() {
      setEditing(false);
      stepperOnStepCompleted(currentStepIndex);
      if (currentStepIndex < steps.length - 1) {
        var newStepIndex = currentStepIndex + 1;
        stepperOnStepChange(newStepIndex);
        setCurrentStepIndex(newStepIndex);
      } else if (currentStepIndex === steps.length - 1) {
        stepperOnCompleted();
      }
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StepperContext.Provider, {
    value: stepperApi
  }, /*#__PURE__*/React.createElement(StepperHeader, {
    activeStep: currentStepIndex,
    stepTitles: stepTitles
  }), /*#__PURE__*/React.createElement("hr", {
    "aria-hidden": true
  }), steps.map(function (step, index) {
    return /*#__PURE__*/React.createElement(Step, {
      key: index,
      visible: index === currentStepIndex
    }, step);
  })));
};

export default Stepper;
export { Step };
